import { lazy, Suspense } from "react";
import { Loading } from "../../elements/Loading";

// Lazy so the email renderers aren't loaded behind every record page.
const Body = lazy(() => import("./designer/CommunicationBody"));

export function CommunicationBody() {
  return (
    <Suspense
      fallback={
        <div className="flex-grow-1 d-flex align-items-center justify-content-center">
          <Loading />
        </div>
      }
    >
      <Body />
    </Suspense>
  );
}

const AudienceSummary = lazy(() => import("./CommunicationAudienceSummary"));

export function LazyCommunicationAudienceSummary({ docked }: { docked?: boolean }) {
  return (
    <Suspense fallback={<Loading />}>
      <AudienceSummary docked={docked} />
    </Suspense>
  );
}

const TestData = lazy(() => import("./CommunicationTestData"));

export function LazyCommunicationTestData() {
  return (
    <Suspense fallback={<Loading />}>
      <TestData />
    </Suspense>
  );
}

const LayoutPicker = lazy(() => import("./CommunicationLayoutPicker"));

export function LazyCommunicationLayoutPicker() {
  return (
    <Suspense fallback={<Loading />}>
      <LayoutPicker />
    </Suspense>
  );
}

const Subject = lazy(() => import("./CommunicationSubjectField"));

export function LazyCommunicationSubject() {
  return (
    <Suspense fallback={null}>
      <Subject />
    </Suspense>
  );
}

const RunAtValidation = lazy(() => import("./CommunicationRunAtValidation"));

export function LazyCommunicationRunAtValidation() {
  return (
    <Suspense fallback={null}>
      <RunAtValidation />
    </Suspense>
  );
}
